export default class CompatibilityHelper {
    static checkColor(color) {
        if (color?.indexOf(`-color`) > 8) {
            color = color.replace(`var(--`, `var(--color-`).replace(`-color)`, `)`);
        }

        return color;
    }
}
